import { Box, Typography, Grid } from "@mui/material";
import React from "react";
import { IQuestions } from "../../interface/iRatingAnalytics";
import RenderQuestionContent from "./renderQuestionContent";

const RenderQuestionsAnalytics = ({
  questions,
  questionsTitel,
}: {
  questions: IQuestions[];
  questionsTitel: string;
}): React.JSX.Element => {
  // split questions in two arrays
  const half: number = Math.ceil(questions.length / 2);
  const firstHalf: IQuestions[] = questions.slice(0, half);
  const secondHalf: IQuestions[] = questions.slice(half);
  let index: number = 0;

  return (
    <React.Fragment>
      {questions.length > 0 && (
        <Box
          sx={{
            backgroundColor: (theme) => theme.palette.grey[100],
            borderRadius: 2,
            px: 2,
            py: 2,
            mb: 2,
          }}
        >
          <Typography
            variant="body1"
            color="initial"
            sx={{
              fontWeight: "bold",
              mb: 1,
            }}
          >
            {questionsTitel}
          </Typography>

          <Grid container spacing={1}>
            <RenderQuestionContent questions={firstHalf} index={index} />
            <RenderQuestionContent
              questions={secondHalf}
              index={secondHalf.length + 1}
            />
          </Grid>
        </Box>
      )}
    </React.Fragment>
  );
};

export default RenderQuestionsAnalytics;
